module.exports = __webpack_public_path__ + "static/media/Defi-para-3.9c9b53e6.jpg";